const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/trading/api-factory');
const merge = require('lodash/fp/merge');
const serviceFactory = require('../resources/trading/service-factory');
const parseRequestMetaData = require('../utils/parse-request-meta-data');
const base64 = require('base-64');
const headers = { Accept: 'application/json' };
function parseValueMovement(data) {
  if ((!data) || data.length == 0) {
    return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/trades/${apiConfig.apiversion}/`,
    authToken: config.authToken,
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';

  return app => app
    .match(`${p}trades.search[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.search(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match(`${p}trades.assetSearch[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.assetSearch(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match(`${p}trades.getSingleSecurityDetail[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getSingleSecurityDetail(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match(`${p}trades.assetsLookupData[{keys:inputParam}]`, requests => Promise.all(
        requests.map(({ req, res }) =>
          service.getAssetsLookupData(req.params)
            .then(response => res.value(response))
            .catch(res.error)
      )))

    .match(`${p}trades.cancelOrder[{keys:inputParam}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.cancelOrder(req.params)
          .then(response => res.value(response))
          .catch(res.error)
    )))

    .match(`${p}trades.approveOrder[{keys:inputParam}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.approveOrder(req.params)
        .then(response => res.value(response))
        .catch(res.error)
    )))
}

module.exports = addRoutes;
